export default __webpack_public_path__ + "static/media/8c.cfe07c16.png";